/**
 *
 */

import { env } from '~/env'

// @ts-expect-error TS(7006) FIXME: Parameter 'imgSrc' implicitly has an 'any' type.
export function getImgResizeUrl(imgSrc, width) {
  if (!imgSrc || !width) return null

  const baseUrl =
    env.VITE_NODE_ENV === 'production'
      ? `https://engage.buffer.com/cdn-cgi/image/width=${width}/`
      : ''

  return `${baseUrl}${imgSrc}`
}
